import type { Entity } from "@cohesive/ui-components";
import { getEntityData } from "@cohesive/ui-components";

type EnrichedOpenTabUrlFields = {
  url?: string;
  html_link?: string;
  web_link?: string;
  granola_url?: string;
};

/**
 * Shallow-merge open-tab URL fields from fetch enrichment into a route-state
 * entity. Detail panes render immediately from navigation state, then fetch
 * vendor links (html_link, granola_url, etc.) — header actions must see those
 * fields once enrichment completes.
 */
export function entityWithEnrichedOpenTabUrl(
  entity: Entity,
  fields: EnrichedOpenTabUrlFields,
): Entity {
  const data = { ...(getEntityData(entity) as Record<string, unknown>) };
  let changed = false;

  for (const key of ["url", "html_link", "web_link", "granola_url"] as const) {
    const value = fields[key];
    if (value && !data[key]) {
      data[key] = value;
      changed = true;
    }
  }

  return changed ? ({ ...entity, data } as Entity) : entity;
}
